"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEligibility = void 0;
var helpers_1 = require("../helpers");
var getEligibilityError = function (errorCode) {
    if (!errorCode)
        return "error_client_error_missing_status";
    switch (errorCode) {
        case 404:
            return "error_not_found";
        case 415:
            return "error_not_json_payload";
        case 500:
            return "error_internal_server_error";
    }
    return "error_unexpected_status_".concat(errorCode);
};
/**
 *
 * Retrieve a list of eligiblity and mature content flags for requested ad placements
 * @param {TEligibilityRequest} placements one or many placements
 * @returns {TEligibilityResponse | TEligibilityErrorResponse | Error} one or many placements in the same order as the requested in the EligibilityRequest and whether an ad is eligible and if Ad Context is aimed at mature audiences.
 */
var getEligibility = function (_a) {
    var fetcher = _a.fetcher, placements = _a.placements;
    return new Promise(function (resolve, reject) {
        fetcher({
            url: "/ads/v1/eligibility",
            body: placements,
        })
            .then(function (response) {
            if (!(response === null || response === void 0 ? void 0 : response.code)) {
                if ((0, helpers_1.getCookie)("debug-ads")) {
                    console.log("fetched eligibility successfully: ", response);
                }
                resolve(response);
            }
            else {
                if ((0, helpers_1.getCookie)("debug-ads")) {
                    console.log("fetched eligibility, but there was an error: ", response);
                }
                var error = response;
                reject({
                    code: error.code,
                    message: getEligibilityError(error.code),
                });
            }
        })
            .catch(function (error) {
            if ((0, helpers_1.getCookie)("debug-ads")) {
                console.log("there was an issue fetching eligibility: ", error);
            }
            reject({
                code: error.code,
                message: getEligibilityError(error.code),
            });
        });
    });
};
exports.getEligibility = getEligibility;
